var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"feedback-type d-inline-block"},[_c('v-icon',{staticClass:"mr-1 pb-1",attrs:{"color":_vm.color,"size":"8"}},[_vm._v("mdi-circle")]),_vm._v(" "+_vm._s(_vm.$t("feedback.types." + _vm.value))+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }